import { z } from 'zod'
import { CompanyIdSchema, UserIdSchema } from '../ids'
import { CardBaseSchema } from './common'

export const UserCardSchema = z.object({
  ...CardBaseSchema.shape,
  entityType: z.literal('user'),
  entityId: UserIdSchema,
  companyId: CompanyIdSchema,
  prefix: z.string().optional(),
  hometown: z.string().optional(),
})
export type UserCard = z.infer<typeof UserCardSchema>

export const PublicUserSchema = z.object({
  ...UserCardSchema.pick({
    slug: true,
    entityType: true,
    prefix: true,
    hometown: true,
  }).shape,
  name: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  title: z.string().optional(),
  startDate: z.number().optional(),
  phone: z.string().optional(),
  avatarUrl: z.string(),
})
export type PublicUser = z.infer<typeof PublicUserSchema>
